import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaChevronRight } from "react-icons/fa";
import Section from "../components/ui/Section";
import PageHeader from "../components/PageHeader/PageHeader";
import "./roadNotes.scss";
import SEO from "../components/seo/SEO";
import { useGetRoadNotesQuery } from "../features/api/youtubeApi";

export default function RoadNotesFeed() {
  const { data, isLoading, isError } = useGetRoadNotesQuery();
  const notes = data?.items || [];

  return (
    <main className="road-notes-page">
      <SEO
        title="Road Notes Journal Feed"
        description="Thoughts shaped by miles, pauses, and the quiet spaces between routes."
        slug="/roadnotes"
      />

      <Section>
        <PageHeader
          title="Road Notes"
          subtitle="Thoughts shaped by miles, pauses, and the roads between."
        />

        <div className="road-notes-grid">
          {/* ===== SKELETON LOADER STATE BLOCKS ===== */}
          {isLoading &&
            Array.from({ length: 3 }).map((_, i) => (
              <article
                key={i}
                className="road-note-card road-note-card--skeleton"
              >
                <div className="skel-thumb" />
                <div className="skel-body">
                  <div className="skel-line" />
                  <div className="skel-line skel-line--short" />
                </div>
              </article>
            ))}

          {/* ===== HIGH-UTILITY LIGHT CARD CONTEXT VIEW MAPS ===== */}
          {!isLoading &&
            !isError &&
            notes.map((note) => (
              <article key={note._id} className="road-note-card fuel-fade-in">
                <div className="card-top-header">
                  <span className="mini-tag">Route Log</span>
                  <time className="card-date">
                    <FaCalendarAlt />{" "}
                    {new Date(note.createdAt).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                      year: "numeric",
                    })}
                  </time>
                </div>

                <h2>{note.title}</h2>

                {/* Extract a short character ceiling snippet teaser line instead of dumping the whole body */}
                <p className="card-excerpt-teaser">
                  {note.excerpt ||
                    "Pull out coordinates map logs and ride along on this country road journey segment segment..."}
                </p>

                {/* 🟢 THE LINK ELEMENT ROUTER ROUTING DIRECTION TRIGGER */}
                <Link
                  to={`/roadnote/${note.slug}`}
                  className="read-story-trigger-btn"
                >
                  Read Journal Story <FaChevronRight />
                </Link>
              </article>
            ))}
        </div>

        {/* Fallback View Frame */}
        {!isLoading && notes.length === 0 && (
          <div className="road-notes-empty">
            <p>No road notes found in this journal section yet. 🛣️</p>
          </div>
        )}
      </Section>
    </main>
  );
}
